import {Injectable} from '@angular/core';

export interface OpeningStatus {
  isOpen: boolean;
  message: string;
  nextOpening?: string;
}

@Injectable({
  providedIn: 'root'
})
export class RestaurantStatusService {

  getCurrentStatus(scheduleData: any): OpeningStatus {
    const now = new Date();
    const today = this.getCurrentDayInEnglish();

    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    const currentTime = `${hours}:${minutes}:${seconds}`;

    const todaySchedule = scheduleData?.days?.find((day: any) => day.day === today);

    if (!todaySchedule) {
      return {
        isOpen: false,
        message: 'Fermé',
        nextOpening: 'Horaires non disponibles pour le moment'
      };
    }

    if (todaySchedule.closed) {
      const nextOpenDay = this.findNextOpenDay(scheduleData, today);
      return {
        isOpen: false,
        message: 'Fermé',
        nextOpening: `Restaurant fermé aujourd'hui - ${nextOpenDay}`
      };
    }

    const currentRange = todaySchedule.ranges?.find((range: any) =>
      this.isTimeInRange(currentTime, range.from, range.to)
    );

    if (currentRange) {
      return {
        isOpen: true,
        message: 'Ouvert',
        nextOpening: `Ouvert jusqu'à ${this.formatTime(currentRange.to)} - Commandez maintenant !`
      };
    } else {
      const nextOpeningTime = this.findNextOpeningTime(scheduleData, today, currentTime);
      return {
        isOpen: false,
        message: 'Fermé',
        nextOpening: nextOpeningTime
      };
    }
  }
  private getCurrentDayInEnglish(): string {
    const days = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];
    return days[new Date().getDay()];
  }

  private isTimeInRange(current: string, start: string, end: string): boolean {
    return current >= start && current <= end;
  }

  private findNextOpeningTime(scheduleData: any, currentDay: string, currentTime: string): string {
    const days = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];
    const currentIndex = days.indexOf(currentDay);

    const todaySchedule = scheduleData.days.find((day: any) => day.day === currentDay);

    if (todaySchedule && !todaySchedule.closed) {
      const futureRanges = todaySchedule.ranges.filter((range: any) => range.from > currentTime);

      if (futureRanges.length > 0) {
        return `Le restaurant ouvre à ${this.formatTime(futureRanges[0].from)} - Vous pouvez commander maintenant`;
      }
    }

    for (let i = 1; i <= 7; i++) {
      const nextDayIndex = (currentIndex + i) % 7;
      const nextDay = days[nextDayIndex];
      const nextDaySchedule = scheduleData.days.find((day: any) => day.day === nextDay);

      if (nextDaySchedule && !nextDaySchedule.closed && nextDaySchedule.ranges.length > 0) {
        const firstOpeningTime = nextDaySchedule.ranges[0].from;
        const dayNames: { [key: string]: string } = {
          'MONDAY': 'lundi',
          'TUESDAY': 'mardi',
          'WEDNESDAY': 'mercredi',
          'THURSDAY': 'jeudi',
          'FRIDAY': 'vendredi',
          'SATURDAY': 'samedi',
          'SUNDAY': 'dimanche'
        };

        if (i === 1) {
          return `Le restaurant ouvre demain à ${this.formatTime(firstOpeningTime)}`;
        } else {
          return `Le restaurant ouvre ${dayNames[nextDay]} à ${this.formatTime(firstOpeningTime)}`;
        }
      }
    }

    return 'Le restaurant est fermé cette semaine - Consultez nos horaires pour plus d\'informations';
  }

  private findNextOpenDay(scheduleData: any, currentDay: string): string {
    const days = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];
    const currentIndex = days.indexOf(currentDay);


    for (let i = 1; i <= 7; i++) {
      const nextDayIndex = (currentIndex + i) % 7;
      const nextDay = days[nextDayIndex];
      const nextDaySchedule = scheduleData.days.find((day: any) => day.day === nextDay);


      if (nextDaySchedule && !nextDaySchedule.closed && nextDaySchedule.ranges.length > 0) {
        const firstOpeningTime = nextDaySchedule.ranges[0].from;
        const dayNames: { [key: string]: string } = {
          'MONDAY': 'lundi',
          'TUESDAY': 'mardi',
          'WEDNESDAY': 'mercredi',
          'THURSDAY': 'jeudi',
          'FRIDAY': 'vendredi',
          'SATURDAY': 'samedi',
          'SUNDAY': 'dimanche'
        };

        if (i === 1) {
          return `Le restaurant ouvre demain à ${this.formatTime(firstOpeningTime)}`;
        } else {
          return `Le restaurant ouvre ${dayNames[nextDay]} à ${this.formatTime(firstOpeningTime)}`;
        }
      }
    }

    return 'Le restaurant est actuellement fermé - Consultez nos horaires pour plus d\'informations';
  }

  private formatTime(time: string): string {
    return time.substring(0, 5);
  }
}
